/* eslint-disable max-len */
import { USER_TYPE } from '../../../../bitConstants/constants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
